import React, { useMemo } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Controller, useFormContext } from 'react-hook-form'

import { MultiSelectDropdown, type MultiSelectOption } from '../../../../components/MultiSelectDropdown/MultiSelectDropdown'
import { type ExportOptionsValues, IntegrationServiceId, type TagsExportOptionConfig } from '../../../../common/integrations'
import { useGetIntegrationEntitiesQuery } from '../../../../store/integrations/integrations'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'

export interface TagDropdownProps {
  serviceId: IntegrationServiceId
  config: TagsExportOptionConfig
}

export const TagDropdown: React.FC<TagDropdownProps> = ({ serviceId, config }) => {
  const accountId = useAppSelector(selectAccountId)
  const { control } = useFormContext<{ exportOptions?: ExportOptionsValues }>()

  const { data, isFetching } = useGetIntegrationEntitiesQuery({ accountId, connector: serviceId, entityType: config.entityType }, { skip: !accountId })

  const tagOptions = useMemo<MultiSelectOption[]>(() => {
    const { defaultTag } = config
    const integrationTagNames = (data?.data.tags ?? []).map((tag) => tag.name).filter((name) => name.toLowerCase() !== defaultTag.toLowerCase())
    return [defaultTag, ...integrationTagNames].map((name) => ({ id: name, label: name, disabled: name === defaultTag }))
  }, [data, config])

  return (
    <Row className='mt-3'>
      <Col xs={12}>
        <div className='lead-extra-small'>Tags</div>
        <Controller
          name='exportOptions.tags'
          control={control}
          render={({ field }) => (
            <MultiSelectDropdown
              name={field.name}
              options={tagOptions}
              initialSelectedOptions={field.value ?? []}
              onSelectedChanged={field.onChange}
              changeOnClose={false}
              creatable={true}
              showSelectedLabels={true}
              placeholder='Select tags'
              loading={isFetching}
            />
          )}
        />
      </Col>
    </Row>
  )
}
